import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFieldArray, useForm } from "react-hook-form";
import ButtonWrapper from "../../components/Button";
import { SummaryCard } from "../../components/StyledComponent";
import { useSelector } from "react-redux";
import ViewCompletionChallan from "../../../../employee/AllViewRemarks/PaymentChallan/ViewCompletionChallan";

const Step5 = ({ formData, handleTabChange, isEmployee }) => {
  const { t } = useTranslation();
  const { documents } = useSelector((state) => state.formMT);
  const tenantId = Digit.ULBService.getStateId();
  const { data, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["MapSubPaymentHeads"]);
  const feeDetail = formData?.taxHeadEstimates?.[0];
  const [taxHead, setTaxHead] = useState([]);
  const paymentHeads = data?.BPA?.MapSubPaymentHeads;
  const isCompounding = formData?.natureOfConstruction === "Compounding";
  console.log(paymentHeads, "paymentheads");

  const paymentHeadsDropdown = paymentHeads?.map((item) => ({
    name: item.label,
    label: item.label,
    value: item.label,
  }));
  const defaultValues = {
    ...formData,
    paymentHeads: formData?.paymentHeads || [{ feeType: "", plotBuildUpArea: "", rate: "" }],
  };
  const { handleSubmit, control, setValue, watch, reset } = useForm({ defaultValues });

  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);

  const { fields, append, remove } = useFieldArray({
    control,
    name: "paymentHeads",
  });

  const handleAddInput = () => {
    append({ feeType: "", plotBuildUpArea: "", rate: "" });
  };
  const handleCalculate = async () => {
    const paymentHeads = watch("paymentHeads");
    const checkedheads = paymentHeads.filter((e) => e.checked);
    console.log({ paymentHeads, checkedheads }, "watchingPaymentHeads");
    formData.paymentHeads = checkedheads;
    const CalulationCriteria = [{ BPA: { ...formData }, tenantId: "up", feeType: "ApplicationFee" }];
    const data = await Digit.OBPSService.bpacalculate({ CalulationCriteria });
    console.log(data, "calculationData");
    setTaxHead(data?.Calculations?.[0]?.taxHeadEstimates?.[0]?.paymentHeads);
  };
  const calculateRate = (plotArea, ranges) => {
    console.log("rangesFromCalculate", ranges, plotArea);

    for (const range of ranges) {
      if (range.area.includes("-")) {
        const [min, max] = range.area.split("-").map(Number);
        if (plotArea >= min && plotArea <= max) {
          return range.rate;
        }
      } else if (range.area.endsWith("+")) {
        const base = parseInt(range.area);
        if (plotArea > base) {
          const additional = plotArea - base;
          const blocks = Math.ceil(additional / 1000);
          return (ranges.find((r) => r.area === "501-1000")?.rate || 0) + blocks * range.ratePerAdditional1000;
        }
      }
    }
    return 0; // default if no match
  };

  const totalTaxHeadAmount = taxHead?.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);
  const totalFeeAmount = parseFloat(feeDetail?.mapRate?.price) || 0;
  const totalAmount = totalTaxHeadAmount + totalFeeAmount;
  // function isValidityExpired(formData) {
  //   if (!formData?.validityDate) return false;

  //   // Break into parts: DD/MM/YYYY
  //   const [day, month, year] = formData.validityDate.split("/").map(Number);

  //   const validityDate = new Date(year, month - 1, day);
  //   const oneYearAfter = new Date(validityDate);
  //   oneYearAfter.setFullYear(oneYearAfter.getFullYear() + 1);

  //   const today = new Date();

  //   return today > oneYearAfter;
  // }
  const onSubmit = (data) => {
    data.paymentHeads = taxHead;
    handleTabChange(3);
  };
  function isValidityExpired() {
    if (!formData?.validityDate) return false;

    // Format: YYYY-MM-DD
    const [year, month, day] = formData.validityDate.split("-").map(Number);

    const validityDate = new Date(year, month - 1, day);
    const oneYearAfter = new Date(validityDate);
    oneYearAfter.setFullYear(oneYearAfter.getFullYear() + 1);

    const today = new Date();

    return today > oneYearAfter;
  }
  const isFeesRequired = isValidityExpired();
  return (
    <section className="groupContainer">
      {isFeesRequired ? (
        <form onSubmit={handleSubmit(onSubmit)}>
          <SummaryCard className="formContainer">
            <div className="formHeaderContainer">
              <h2 className="formHeading">Fee Details</h2>
            </div>
            <ViewCompletionChallan formData={formData} />
          </SummaryCard>

          {/*       
          {!formData?.edcrNumber && !isCompounding && (
            <Button
              className="gradientButton mb-4"
              variant="contained"
              color="success"
              size="medium"
              style={{
                color: "white",
                borderRadius: "24px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "10px",
                marginLeft: "50%",
              }}
              onClick={handleCalculate}
            >
              Calculate
            </Button>
          )} */}
          {/* {!formData?.edcrNumber && !isCompounding && (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="fee table">
                <TableHead>
                  <TableRow>
                    <TableCell color="white">Fee Type</TableCell>
                    <TableCell color="white" align="right">
                      Built Up Area (sqmt.)
                    </TableCell>
                    <TableCell color="white" align="right">
                      Rate (₹)
                    </TableCell>
                    <TableCell color="white" align="right">
                      Amount (₹)
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {taxHead?.map((row, index) => (
                    <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <TableCell component="th" scope="row">
                        {row.feeType}
                      </TableCell>
                      <TableCell align="right">{row.plotBuildUpArea}</TableCell>
                      <TableCell align="right">{row.rate}</TableCell>
                      <TableCell align="right">{row.amount}</TableCell>
                    </TableRow>
                  ))}
                  <TableRow key={0} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                    <TableCell component="th" scope="row">
                      Fee On Plot
                    </TableCell>
                    <TableCell align="right">{formData?.totalBuildUpArea}</TableCell>
                    <TableCell align="right">{feeDetail?.mapRate?.unitPrice}</TableCell>
                    <TableCell align="right">{feeDetail?.mapRate?.price}</TableCell>
                  </TableRow>
                  <TableRow sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>
                    <TableCell colSpan={3} align="right">
                      <strong>Total Amount</strong>
                    </TableCell>
                    <TableCell align="right">
                      <strong>{totalAmount.toFixed(2)}</strong>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          )} */}

          {!isEmployee && (
            <div className="footerContainer">
              <div className="buttonWrapper">
                <ButtonWrapper
                  variant="contained"
                  color="error"
                  size="medium"
                  label="Prev"
                  sx={{ backgroundColor: "#CCC" }}
                  onClick={() => handleTabChange(1)}
                />
                <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
              </div>
            </div>
          )}
        </form>
      ) : (
        <React.Fragment>
          {" "}
          <SummaryCard className="formContainer">No Fees is required</SummaryCard>
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Prev"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleTabChange(1)}
              />
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label="Next"
                type="submit"
                onClick={() => handleTabChange(3)}
                sx={{ backgroundColor: "#157CB3" }}
              />
            </div>
          </div>
        </React.Fragment>
      )}
    </section>
  );
};
export default Step5;
